'use client';

import { useReducedMotion } from 'framer-motion';
import type { ReactNode } from 'react';

interface SectionScrollShortcutProps {
  targetId: string;
  className?: string;
  children: ReactNode;
}

export const SectionScrollShortcut = ({
  targetId,
  className,
  children,
}: SectionScrollShortcutProps) => {
  const shouldReduceMotion = useReducedMotion();

  //* 섹션은 카드가 없으면 렌더되지 않는다 — 그때는 아무 일도 하지 않는다
  const handleClick = () => {
    document.getElementById(targetId)?.scrollIntoView({
      behavior: shouldReduceMotion ? 'auto' : 'smooth',
      block: 'start',
    });
  };

  return (
    <button type="button" className={className} onClick={handleClick}>
      {children}
    </button>
  );
};
